<template>
  <div class="sticker" :style="{zIndex: zIndexNum,}">
    <img :src="src" class="stickerImg" alt="" />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    zIndexNum: {
      type: Number,
      required: false,
    },
    src:{
      type:String,
      default:"../assets/imgs/sticker.png"
    }
  },
  computed: {
    ...mapState({
      searches: state => state.home.searches,
    })
  }
};
</script>

<style lang="less" scoped>
.sticker {
  position: absolute;
  width: 100%;
  min-height: auto;
  top: 0;
  left: 0;
  z-index:9;
  img.stickerImg{
    width: 100%;
    display: block;
    border-radius: 4px;
    overflow: hidden;
  }
}
</style>
